export const fonts = {
	fontFamily: 'WWBeta8R',
	fontFamilyTitle: 'WWBeta8R',
}
